/**
 * Form validation
 */

const formValidation = () => {

    const classBound = 'has-bound-validation';
    const selector = 'needs-validation';

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.getElementsByClassName(selector);

    // Loop over them and prevent submission
    //for (let form of forms) {
    for (let i = 0; i < forms.length; i++) {
        let form = forms[i];

        if (form.classList.contains(classBound)) {
            continue;
        }

        form.addEventListener('submit', (e) => {
            if (form.checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
            }
            form.classList.add('was-validated');
        }, false);

        form.classList.add(classBound);
    }
}

export default formValidation;

window.addEventListener('load', formValidation, false);
